export default __webpack_public_path__ + "efdc866.png";